<template>
  <div>
    <h4 class="mb-4 text-semibold">Api de conversões</h4>
    <div class="cards-row">
      <feature-card
        v-for="option in options"
        :key="option.title"
        class="w-100"
        v-bind="option"
        color="blue"
        @click="$router.push({ name: option.route })"
      />
    </div>
  </div>
</template>

<script>
import FeatureCard from "@/components/FeatureCard.vue";

const options = [
  {
    icon: "ph ph-facebook-logo",
    title: "Api de conversões do Facebook",
    subtitle: "Integre seu produto à API de conversões do Facebook",
    route: "product-facebook-pixel"
  },
  {
    icon: "ph ph-google-logo",
    title: "Api do Google Analytics",
    subtitle: "Integre seu produto à API do Google Analytics",
    route: "product-google-analytics"
  }
];
export default {
  components: { FeatureCard },
  data() {
    return {
      options
    };
  }
};
</script>
<style lang="scss">
.cards-row {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 28px;
}
</style>
